import { render, staticRenderFns } from "./SiteBatimentTabs.vue?vue&type=template&id=540cb432&scoped=true&"
import script from "./SiteBatimentTabs.vue?vue&type=script&lang=js&"
export * from "./SiteBatimentTabs.vue?vue&type=script&lang=js&"
import style0 from "./SiteBatimentTabs.vue?vue&type=style&index=0&id=540cb432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540cb432",
  null
  
)

export default component.exports